if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      swapProductUtility = undefined;
      abortController = undefined;

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');

        if( (window.location.search.includes("?variant=")) && window.location.pathname.includes("products/american-gift-card") ) {
          let price = document.querySelector(".price-item--regular");
          let buy_btns = document.querySelectorAll("span.buy-button-span");
          buy_btns.forEach( (btn) => {
            btn.innerHTML = `ADD TO BAG  <span class="add-bag-dash">-</span> ${price.innerText}`;
          } );
        }

        console.log("--", window.product_info);
        let buy_btns = document.querySelectorAll("span.buy-button-span");
        buy_btns.forEach( (btn) => {
          btn.innerHTML = `ADD TO BAG  <span class="add-bag-dash">-</span> $${(window.product_info.price / 100).toFixed(2)}`;
        } );
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChangeStart,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.swapProductUtility.addPreProcessCallback(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.swapProductUtility = new HTMLUpdateUtility();
        this.swapProductUtility.addPreProcessCallback((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.swapProductUtility.addPostProcessCallback((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
          publish(PUB_SUB_EVENTS.sectionRefreshed, {
            data: {
              sectionId: this.sectionId,
              resource: {
                type: SECTION_REFRESH_RESOURCE_TYPE.product,
                id: newNode.dataset.productId,
              },
            },
          });
        });
      }

      handleOptionValueChange({ data: { event, target, variant } }) {
        if (!this.contains(event.target)) return;

        const targetUrl = target.dataset.productUrl || this.dataset.url;

        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();

        let callback = () => {};
        let productUrl = this.getProductInfoUrl(targetUrl, variant?.id);
        if (this.dataset.url !== targetUrl) {
          this.updateURL(targetUrl, variant?.id);
          this.updateShareUrl(targetUrl, variant?.id);
          callback = this.handleSwapProduct();
          productUrl = this.getProductInfoUrl(targetUrl, variant?.id, true);
        } else if (!variant) {
          this.setUnavailable();
          callback = (html) => {
            this.pickupAvailability?.update(variant);
            this.updateOptionValues(html);
          };
        } else {
          this.updateURL(targetUrl, variant.id);
          this.updateShareUrl(targetUrl, variant.id);
          this.updateVariantInputs(variant.id);
          callback = this.handleUpdateProductInfo(variant);
        }

        this.renderProductInfo(productUrl, target.id, callback);
      }

      handleSwapProduct() {
        return (html) => {
          this.productModal?.remove();

          // If we are in an embedded context (quick add, featured product, etc), only swap product info.
          // Otherwise, refresh the entire page content and sibling sections.
          if (this.dataset.updateUrl === 'false') {
            this.swapProductUtility.viewTransition(this, html.querySelector('product-info'));
          } else {
            this.swapProductUtility.viewTransition(document.querySelector('main'), html.querySelector('main'));
          }
        };
      }

      renderProductInfo(productUrl, targetId, callback) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(productUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          });
      }

      getProductInfoUrl(url, variantId, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (variantId) {
          params.push(`variant=${variantId}`);
        } else {
          const optionValues = this.variantSelectors.selectedOptionValues;
          if (optionValues.length) {
            params.push(`option_values=${optionValues.join(',')}`);
          }
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) this.variantSelectors.innerHTML = variantSelects.innerHTML;
      }

      changeInfo(pos) {
        let variantInfo = document.querySelectorAll('.hero-information');
        for (let i = 0; i < variantInfo.length; i++) {
          if (pos == i) {
            variantInfo[i].style.display = 'block';
          } else {
            variantInfo[i].style.display = 'none';
          }
        }

      }

      updateLabels() {
        let variantInputs = document.querySelectorAll('.variant_input_label');
        for (let i = 0; i < variantInputs.length; i++) {
          // console.log("Adding change " + i);
          variantInputs[i].addEventListener('click', () => {
            this.changeInfo(i);
          });
        }
      }

      handleUpdateProductInfo(variant) {
        return (html) => {
          // this.pickupAvailability?.update(variant);
          this.updateMedia(html, variant?.featured_media?.id);
          this.updateOptionValues(html);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };
          this.updateLabels();

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

          let buy_btns = document.querySelectorAll("span.buy-button-span");
          buy_btns.forEach( (btn) => {
            btn.innerHTML = `ADD TO BAG  <span class="add-bag-dash">-</span> $${(variant.price / 100).toFixed(2)}`;
          } );

          window.product_info = variant;

          if(window.location.pathname.includes("products/american-gift-card")){
            let price = document.querySelector(".price-item--regular");
            let buy_btns = document.querySelectorAll("span.buy-button-span");
            buy_btns.forEach( (btn) => {
              btn.innerHTML = `ADD TO BAG  <span class="add-bag-dash">-</span> ${price.innerText}`;
            } );
          }

        };

      }

      updateGalleryMedia(color) {
        let li_imgs_show = document.querySelectorAll(`.thumbnail-list li[data-variant-color="${color}" i]`);
        let li_imgs_hide = document.querySelectorAll(`.thumbnail-list li:not([data-variant-color="${color}" i])`);
        let li_imgs_show_mobile = document.querySelectorAll(`.slider--mobile li[data-variant-color="${color}" i]`);
        let li_imgs_hide_mobile = document.querySelectorAll(`.slider--mobile li:not([data-variant-color="${color}" i])`);

        li_imgs_hide.forEach((no_show) => {
          no_show.classList.add("hide-me");
        });
        li_imgs_hide_mobile.forEach((no_show) => {
          no_show.classList.add("hide-me");
        });

        li_imgs_show.forEach((show) => {
          show.classList.remove("hide-me");
        });
        li_imgs_show_mobile.forEach((show) => {
          show.classList.remove("hide-me");
        });
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        let selected = this.querySelector(".variant_input:checked");
        if (selected) this.updateGalleryMedia(selected.value);
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      updateShareUrl(url, variantId) {
        this.querySelector('share-url')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        if (variantFeaturedMediaId) {
          // set featured media as active in the media gallery
          this.querySelector(`media-gallery`)?.setActiveMedia?.(
            `${this.dataset.section}-${variantFeaturedMediaId}`,
            false
          );

          // update media modal
          const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
          const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
          if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
        }
      }

      setQuantityBoundries(quantityInput = this.quantityInput) {
        const data = {
          cartQuantity: quantityInput.dataset.cartQuantity ? parseInt(quantityInput.dataset.cartQuantity) : 0,
          min: quantityInput.dataset.min ? parseInt(quantityInput.dataset.min) : 1,
          max: quantityInput.dataset.max ? parseInt(quantityInput.dataset.max) : null,
          step: quantityInput.step ? parseInt(quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        quantityInput.min = min;

        if (max) {
          quantityInput.max = max;
        } else {
          quantityInput.removeAttribute('max');
        }
        quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        const formIds = [`Quantity-Form-${sectionId}`, `Quantity-Form-${sectionId}-mobile`];
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];

        for (const formId of formIds) {
          const quantityForm = this.querySelector(`#${formId}`);
          const quantityFormUpdated = html.getElementById(formId);
          if (!quantityForm || !quantityFormUpdated) continue;

          for (const selector of selectors) {
            const current = quantityForm.querySelector(selector);
            const updated = quantityFormUpdated.querySelector(selector);
            if (!current || !updated) continue;
            if (selector === '.quantity__input') {
              const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
              for (const attribute of attributes) {
                const valueUpdated = updated.getAttribute(attribute);
                if (valueUpdated !== null) {
                  current.setAttribute(attribute, valueUpdated);
                } else {
                  current.removeAttribute(attribute);
                }
              }
              this.setQuantityBoundries(current);
            } else {
              current.innerHTML = updated.innerHTML;
            }
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

function productTabs() {
  const tabs = document.querySelectorAll('.shopify-tabs li a');
  if(tabs.length === 0) return;
  tabs.forEach(tab => {
    tab.addEventListener('click', (event)=> {
      event.preventDefault();
      const itemId = tab.href.split('#')[1];
      const itemToView = document.querySelector(`#${itemId}`);
      if(!itemToView) return;
      scrollToEl(itemToView)
    })
  })
}

function scrollToEl(element) {
  const headerOffset = 140;

  const targetTop = element.getBoundingClientRect().top + window.scrollY;
  const scrollPosition = targetTop - headerOffset;

  window.scrollTo({
    top: scrollPosition,
    behavior: 'smooth'
  });
}

document.addEventListener('DOMContentLoaded', ()=> productTabs())
